<template>
  <div>
    <v-dialog v-model="orderDetailsDialog" max-width="1500px" persistent>
      <v-card fluid grid-list color="#88D2FA" class="mt-4">
        <!-- This layout below is for the information fields. -->
        <v-layout row wrap>
          <v-card-title class="mt-2">
            <v-btn round color="secondary" @click="closeOrderDetailsDialog"
              >Close</v-btn
            >
          </v-card-title>
          <v-card-text>
            <h2>{{ $translate("CQ_USER_DETAILS") }}</h2>
          </v-card-text>
          <v-flex xs5 offset-xs1>
            <h3>{{ $translate("USERNAME") }}</h3>
            <p class="newFontSize">{{ orderDetails.UserName }}</p>
          </v-flex>
          <v-flex xs5 offset-xs1>
            <h3>{{ $translate("PHONE_NR") }}</h3>
            <p class="newFontSize">{{ orderDetails.UserPhoneNumber }}</p>
          </v-flex>
          <v-flex xs5 offset-xs1>
            <h3>{{ $translate("REGISTER_FORM_EMAIL") }}</h3>
            <a class="newFontSize" :href="'mailto:' + orderDetails.UserEmail">
              {{ orderDetails.UserEmail }}
            </a>
          </v-flex>
          <v-card-text>
            <h2 class="mt-2">{{ $translate("ORDER_DETAILS") }}</h2>
          </v-card-text>

          <v-flex xs5 offset-xs1>
            <h3 class="mt-2 mb-4">
              {{ $translate("ORDER_STATUS") }} : {{ orderDetails.Status }}
            </h3>
          </v-flex>

          <!-- Order items -->
          <v-flex xs12>
            <v-layout row justify-center>
              <v-flex xs10>
                <v-card>
                    <template v-for="(item, index) in orderItems">
                        <v-card-text :key="item.OrderItemId">
                        <v-layout row justify-space-around align-center :key="item.OrderItemId">
                          <!-- For name -->
                          <v-flex
                            v-if="
                              item.OrderItemType !==
                              ORDER_ITEM_TYPE_SPECIAL_REQUEST
                            "
                            xs4
                          >
                            <v-list-tile-content>
                              <h3
                                v-if="
                                  item.OrderItemType === ORDER_ITEM_TYPE_PRODUCT
                                "
                              >
                                {{ item.OrderProduct.ProductName }}
                              </h3>
                              <h3
                                v-else-if="
                                  item.OrderItemType ===
                                    ORDER_ITEM_TYPE_PRICE_CATEGORY ||
                                  item.OrderItemType ===
                                    ORDER_ITEM_TYPE_DELIVERY_COST
                                "
                              >
                                {{ item.OrderPriceCategory.PriceCategoryName }}
                              </h3>
                              <h3
                                v-else-if="
                                  item.OrderItemType ===
                                  ORDER_ITEM_TYPE_DELIVERY_FEE
                                "
                              >
                                {{ item.OrderItemType }}
                              </h3>
                            </v-list-tile-content>
                          </v-flex>
                          <v-flex v-else xs4>
                            <div
                              v-if="item.OrderSpecialRequest.SpecialRequest.length >= 50"
                            >
                              <h3
                                v-if="!item.ReadMoreActivated" 
                                style="overflow-wrap: break-word"
                              >
                                {{ item.OrderSpecialRequest.SpecialRequest.slice(0, 50) }} ...
                              </h3>
                              <a 
                                v-if="!item.ReadMoreActivated" 
                                @click="readMoreRequest(item)" 
                                href="#"
                              >
                                Read more ...
                              </a>
                              <h3
                                v-if="item.ReadMoreActivated"  
                                style="overflow-wrap: break-word"
                              > 
                                {{ item.OrderSpecialRequest.SpecialRequest }}
                              </h3>
                              <a 
                                v-if="item.ReadMoreActivated" 
                                @click="readLessRequest(item)" 
                                href="#"
                              >
                                Read less
                              </a>
                            </div>
                            <div
                              v-else
                            >
                              <h3
                                style="overflow-wrap: break-word"
                              > 
                                {{ item.OrderSpecialRequest.SpecialRequest }}
                              </h3>
                            </div>

                          <!-- <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn icon ripple v-on="on">
                                <v-icon color="primary">info</v-icon>
                              </v-btn>
                            </template>
                            <span
                              >This is a request from partner. You can add
                              a reply, vat info, and price for the
                              request.</span
                            >
                          </v-tooltip> -->
                          </v-flex>

                          <!-- For quantity -->
                          <v-flex
                            v-if="
                              item.OrderItemType !==
                              ORDER_ITEM_TYPE_SPECIAL_REQUEST
                            "
                            xs2
                          >
                            <v-layout row align-center justify-end>
                              <v-flex>
                                <v-list-tile-content>
                                  <v-text-field
                                    v-if="
                                      item.OrderItemType ===
                                      ORDER_ITEM_TYPE_PRODUCT
                                    "
                                    v-model="item.OrderProduct.Quantity"
                                    type="number"
                                    @change="productItemQuantityChanged(item)"
                                    :disabled="
                                      orderDetails.Status !==
                                      ORDER_PARTNER_CONFIRMATION_NEEDED
                                    "
                                  ></v-text-field>
                                  <v-text-field
                                    v-if="
                                      item.OrderItemType ===
                                      ORDER_ITEM_TYPE_PRICE_CATEGORY
                                    "
                                    v-model="item.OrderPriceCategory.Quantity"
                                    type="number"
                                    disabled
                                  ></v-text-field>
                                </v-list-tile-content>
                              </v-flex>
                              <v-flex>
                                <v-list-tile-content>
                                  <p
                                    v-if="
                                      item.OrderItemType !==
                                      ORDER_ITEM_TYPE_DELIVERY_FEE
                                    "
                                  >
                                    {{ getItemUnit(item) }}
                                  </p>
                                </v-list-tile-content>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex v-else xs2>
                            <v-list-tile-content>
                              <v-textarea
                                no-resize
                                v-model="
                                  item.OrderSpecialRequest.PartnerResponse
                                "
                                :label="
                                  getPartnerResponseLabel(
                                    item.OrderSpecialRequest
                                  )
                                "
                                :disabled="
                                  orderDetails.Status !==
                                  ORDER_PARTNER_CONFIRMATION_NEEDED
                                "
                                single-line
                              ></v-textarea>
                            </v-list-tile-content>
                          </v-flex>

                          <!-- For unit price -->
                          <v-flex
                            v-if="
                              item.OrderItemType !==
                              ORDER_ITEM_TYPE_SPECIAL_REQUEST
                            "
                            xs2
                          >
                            <v-list-tile-content>
                              <v-layout row align-center justify-space-around>
                                <v-flex>
                                  <p
                                    v-if="
                                      item.OrderItemType ===
                                      ORDER_ITEM_TYPE_PRODUCT
                                    "
                                  >
                                    {{ pricePrefix }}
                                    {{ item.OrderProduct.ItemPrice }}
                                  </p>
                                  <p
                                    v-else-if="
                                      item.OrderItemType ===
                                      ORDER_ITEM_TYPE_PRICE_CATEGORY
                                    "
                                  >
                                    {{ pricePrefix }}
                                    {{
                                      item.OrderPriceCategory.PriceCategoryPrice
                                    }}
                                  </p>
                                </v-flex>
                                <v-flex>
                                  <p
                                    v-if="
                                      item.OrderItemType !==
                                        ORDER_ITEM_TYPE_DELIVERY_FEE &&
                                      getItemUnit(item) !== ''
                                    "
                                    class="ml-2"
                                  >
                                    / {{ getItemUnit(item) }}
                                  </p>
                                </v-flex>
                              </v-layout>
                            </v-list-tile-content>
                          </v-flex>
                          <v-flex v-else xs2>
                            <v-list-tile-content
                              v-if="
                                orderDetails.Status ===
                                ORDER_PARTNER_CONFIRMATION_NEEDED
                              "
                            >
                              <v-select
                                v-model="item.OrderSpecialRequest.VatId"
                                :items="vatList"
                                item-text="VatId"
                                item-value="VatId"
                                label="VAT"
                                required
                                :rules="vatRule"
                              ></v-select>
                            </v-list-tile-content>
                          </v-flex>

                          <!-- For sub total price -->
                          <v-flex xs1>
                            <v-list-tile-content>
                              <v-text-field
                                v-if="
                                  item.OrderItemType === ORDER_ITEM_TYPE_PRODUCT
                                "
                                :prefix="pricePrefix"
                                v-model="item.OrderProduct.ItemTotalPrice"
                                type="number"
                                @change="productItemTotalPriceChanged(item)"
                                :disabled="
                                  orderDetails.Status !==
                                  ORDER_PARTNER_CONFIRMATION_NEEDED
                                "
                              ></v-text-field>
                              <v-text-field
                                v-else-if="
                                  item.OrderItemType ===
                                    ORDER_ITEM_TYPE_PRICE_CATEGORY ||
                                  item.OrderItemType ===
                                    ORDER_ITEM_TYPE_DELIVERY_COST
                                "
                                :prefix="pricePrefix"
                                :value="
                                  item.OrderPriceCategory.Quantity *
                                  item.OrderPriceCategory.PriceCategoryPrice
                                "
                                type="number"
                                disabled
                              ></v-text-field>
                              <v-text-field
                                v-else-if="
                                  item.OrderItemType ===
                                  ORDER_ITEM_TYPE_DELIVERY_FEE
                                "
                                :prefix="pricePrefix"
                                v-model="item.OrderDeliveryFee.DeliveryPrice"
                                type="number"
                                :disabled="
                                  orderDetails.Status !==
                                  ORDER_PARTNER_CONFIRMATION_NEEDED
                                "
                              ></v-text-field>
                              <v-text-field
                                v-else-if="
                                  item.OrderItemType ===
                                  ORDER_ITEM_TYPE_SPECIAL_REQUEST
                                "
                                :prefix="pricePrefix"
                                v-model="item.OrderSpecialRequest.Price"
                                type="number"
                                :disabled="
                                  orderDetails.Status !==
                                  ORDER_PARTNER_CONFIRMATION_NEEDED
                                "
                              ></v-text-field>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                        </v-card-text>

                        <!-- For remove button -->
                        <!-- <v-list-tile-action
                          v-if="
                            orderDetails.Status ===
                            ORDER_PARTNER_CONFIRMATION_NEEDED
                          "
                        >
                          <v-btn
                            :disabled="
                              orderItems.length === 1 ||
                              item.OrderItemType !== ORDER_ITEM_TYPE_PRODUCT
                            "
                            fab
                            small
                            color="secondary"
                            @click="deleteOrderItem(item)"
                          >
                            <v-icon>remove</v-icon>
                          </v-btn>
                        </v-list-tile-action> -->

                      <!-- </v-list-tile> -->

                      <v-divider
                        v-if="index + 1 < orderItems.length"
                        :key="index"
                      ></v-divider>
                    </template>
                  <!-- </v-list> -->
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- Button to add a product -->
          <!-- <v-flex
            v-if="orderDetails.Status === ORDER_PARTNER_CONFIRMATION_NEEDED"
          >
            <v-btn fab small color="primary">
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex> -->

          <!-- Total price -->
          <!-- <v-flex>
            <v-layout justify-end class="my-4">
              <h2>Total: {{ pricePrefix }} {{ orderTotalPrice }}</h2>
            </v-layout>
          </v-flex> -->

          <!-- Date and time for order -->
          <v-flex xs12 class="mt-4">
            <v-layout row justify-center>
              <v-flex xs4 class="mr-2">
                <!-- For Start Date -->
                <v-combobox
                  v-model="startDateSelected"
                  :items="startDates"
                  label="Start Date"
                  :disabled="dateTimeDisabled"
                  outline
                  return-masked-value
                  persistent-hint
                  @change="getStartBatches"
                ></v-combobox>
              </v-flex>
              <v-flex xs4 class="ml-2">
                <!-- For Start Time -->
                <v-combobox
                  v-model="startTimeSelected"
                  :items="startTimes"
                  item-text="StartTime"
                  item-value="StartTime"
                  label="Start Time"
                  :disabled="dateTimeDisabled"
                  outline
                  return-masked-value
                  persistent-hint
                ></v-combobox>
              </v-flex>
              <!-- <v-flex
                v-if="orderDetails.Status === ORDER_PARTNER_CONFIRMATION_NEEDED"
                xs2
                class="ml-2"
              >
                <v-btn color="secondary" @click="enableDateTimeSelection"
                  >Change Date and Time</v-btn
                >
              </v-flex> -->
            </v-layout>
          </v-flex>

          <!-- Reject and Accept button -->
          <v-flex
            v-if="orderDetails.Status === ORDER_PARTNER_CONFIRMATION_NEEDED"
            xs12
            class="mb-4"
          >
            <v-layout row justify-center>
              <!-- For Reject Button -->
              <v-btn
                large
                color="secondary"
                @click="rejectBookingByPartner"
                :loading="processingRejectOrder"
                >Reject Order</v-btn
              >
              <!-- For Accept Button -->
              <v-btn
                large
                color="primary"
                @click="confirmBookingByPartner"
                :loading="processingAcceptOrder"
                >Accept Order</v-btn
              >
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout justify-center row wrap>
          <v-flex xs12>
            <v-card class="elevation-0 transparent mt-4">
              <v-layout row justify-center>
                <qrcode
                  class="mb-2"
                  :value="orderDetails.OrderId"
                  :options="{ width: 100 }"
                />
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout align-content-center row wrap>
          <v-flex xs12>
            <v-card class="elevation-0" color="#88D2FA">
              <v-divider />
              <h3 class="cardTitle ma-0 pa-2">{{ orderDetails.OrderId }}</h3>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!--this flex is used to show the month calendar-->
    <v-flex id="month" class="mt-2 pa-0 mb-5 pb-3">
      <OperationalScreen_QuadrantToolbar
        :componentId="properties.componentId"
        :headers="headers"
        :title="eventCalendarTitle"
        :toolBarOptions="false"
        class="quadrant"
        :webshopCalendarHelperInfo="true"
      />
      <v-sheet class="calendar">
        <v-calendar
          ref="calendar"
          :now="today"
          v-model="month"
          :value="today"
          width="344px"
          :type="calendarType"
          color="primary"
          class="scrollingPossible"
          :interval-format="intervalFormat"
        >
          <!--events in month view dont look at time because its not relevant-->
          <template v-slot:day="{ date }">
            <template v-for="order in ordersMap[date]">
              <div
                :key="order.OrderId"
                v-html="order.OrderId"
                v-ripple
                class="my-event mb-1"
                :style="getOrderStyle(order)"
                @click="getOrderById(order)"
              ></div>
            </template>
          </template>
        </v-calendar>
        <!--this is the toolbar at the bottom of the calendar-->
        <v-toolbar>
          <!--these are the buttons to go forward/backwords 1 month-->
          <v-btn
            fab
            outline
            small
            absolute
            left
            color="primary"
            @click="$refs.calendar.prev()"
          >
            <v-icon dark> keyboard_arrow_left </v-icon>
          </v-btn>
          <v-btn
            fab
            outline
            small
            absolute
            right
            color="primary"
            @click="$refs.calendar.next()"
          >
            <v-icon dark> keyboard_arrow_right </v-icon>
          </v-btn>
        </v-toolbar>
      </v-sheet>
    </v-flex>

    <!-- Dialog when request succeeded -->
    <v-dialog
      v-model="successDialog"
      width="500px"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline green"
          primary-title
        >
          <v-layout row justify-center>
            <v-icon dark x-large>check_circle_outline</v-icon>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <h3>{{ successMsg }}</h3>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="closeSuccessDialog"
          >
            {{ $translate("OK") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog when request failed -->
    <v-dialog
      v-model="failureDialog"
      width="500px"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline red"
          primary-title
        >
          <v-layout row justify-center>
            <v-icon dark x-large>error_outline</v-icon>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <h3>{{ failureMsg }}</h3>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="closeFailureDialog"
          >
            {{ $translate("OK") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import moment from "moment";
// eslint-disable-next-line camelcase,import/extensions
import OperationalScreen_BaseQuadrant from "./OperationalScreen_BaseQuadrant";
// eslint-disable-next-line camelcase,import/extensions
import OperationalScreen_QuadrantToolbar from "./OperationalScreen_QuadrantToolbar";
import * as dssRequest from "../../api/dssRequest";

Vue.component(VueQrcode.name, VueQrcode);

export default {
  name: "OperationalScreen_WebshopOverview",
  extends: OperationalScreen_BaseQuadrant,
  props: {
    boxConfig: {},
  },
  components: {
    OperationalScreen_QuadrantToolbar,
    VueQrcode,
  },
  data: () => ({
    timeout: false,
    eventCalendar: {},
    orderDetailsDialog: false,
    eventCalendarTitle: "",
    today: moment().format("YYYY-MM-DD"),
    month: moment().format("YYYY-MM-DD"),
    calendarType: "month",
    now: null,
    ordersArray: [],
    ordersMap: {},
    orderDetails: {},
    orderItems: [],
    pricePrefix: "€",
    startDates: [], // ["21-10-2020", "22-10-2020"],
    startTimes: [], // [{ StartTime: "09:00" }, { StartTime: "10:00" }],
    startDateSelected: "",
    startTimeSelected: "",
    endTimeSelected: "",
    dateTimeDisabled: true,
    vatList: [],
    vatRule: [(v) => !!v || "Vat for the request is required"],
    processingAcceptOrder: false,
    processingRejectOrder: false,
    successDialog: false,
    failureDialog: false,
    successMsg: '',
    failureMsg: '',

    // Order statuses
    ORDER_CONFIRMED: "Confirmed",
    ORDER_DONE: "Done",
    ORDER_CANCELLED: "Cancelled",
    ORDER_WAITING_FOR_PAYMENT: "WaitingForPayment",
    ORDER_PARTNER_CONFIRMATION_NEEDED: "PartnerConfirmation",
    ORDER_REQUESTED_PAYMENT: "RequestedPayment",

    // Types of order item
    ORDER_ITEM_TYPE_PRODUCT: "Product",
    ORDER_ITEM_TYPE_PRICE_CATEGORY: "PriceCategory",
    ORDER_ITEM_TYPE_DELIVERY_COST: "DeliveryCost",
    ORDER_ITEM_TYPE_DELIVERY_FEE: "DeliveryFee",
    ORDER_ITEM_TYPE_SPECIAL_REQUEST: "SpecialRequest",
  }),
  computed: {
    orderTotalPrice() {
      let totalPrice = 0;

      this.orderItems.forEach(
        orderItem => {
          if(orderItem.OrderItemType === this.ORDER_ITEM_TYPE_PRODUCT) {
            totalPrice += orderItem.OrderProduct.ItemTotalPrice
          } else if(orderItem.OrderItemType === this.ORDER_ITEM_TYPE_PRICE_CATEGORY || orderItem.OrderItemType === this.ORDER_ITEM_TYPE_DELIVERY_COST) {
            totalPrice += orderItem.OrderPriceCategory.Quantity * orderItem.OrderPriceCategory.PriceCategoryPrice;
          } else if(orderItem.OrderItemType === this.ORDER_ITEM_TYPE_DELIVERY_FEE) {
            totalPrice += orderItem.OrderDeliveryFee.DeliveryPrice;
          } else if(orderItem.OrderItemType === this.ORDER_ITEM_TYPE_SPECIAL_REQUEST) {
            totalPrice += orderItem.OrderSpecialRequest.Price;
          }
        }
      );

      return Number(totalPrice).toFixed(2);
    }
  },
  mounted() {
    this.$refs.calendar.scrollToTime("08:00");
    if (this.properties.hasOwnProperty("event")) {
      this.eventCalendar = this.properties.event;
      this.eventCalendarTitle = this.properties.event.EventTranslationName;
    } else {
      this.eventCalendar = this.$store.getters.getEventIdForCalendar;
      this.eventCalendarTitle = this.$store.getters.getEventIdForCalendar.Name;
    }
    this.timeout = true;
    this.getBookingCalendar();
    this.getVatInfo();

    // Update Orders every 5 minutes
    setInterval(this.getBookingCalendar, 300000);
  },
  beforeDestroy() {
    clearInterval(this.getBookingCalendar);
  },
  methods: {
    getBookingCalendar() {
      const payload = {};

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The request [getBookingCalendar] to Event [%s] on [OperationalScreen_WebshopOverview] succeeded",
            this.eventCalendar.EventId,
            response
          );

          this.ordersArray = [];
          this.ordersMap = {};
          if (response.data.hasOwnProperty("Orders")) {
            response.data.Orders.forEach((arrayItem) => {
              const orderTmp = Object.assign({}, arrayItem);
              this.ordersArray.push(orderTmp);

              let dateTmp = moment(arrayItem.StartDate, "DD-MM-YYYY").format(
                "YYYY-MM-DD"
              );
              const orderTmpForMap = Object.assign({}, arrayItem);
              (this.ordersMap[dateTmp] = this.ordersMap[dateTmp] || []).push(
                orderTmpForMap
              );
            });
          }

          // Sort orders by StartTime for each date
          this.sortOrdersMap();
          console.log("ordersMap: ", this.ordersMap);
        },
        (error) => {
          console.log(
            "The request [getBookingCalendar] to Event [%s] on [OperationalScreen_WebshopOverview] failed",
            this.eventCalendar.EventId,
            error
          );
        },
        "getBookingCalendar",
        this.eventCalendar.EventId,
        payload
      );
    },
    getVatInfo() {
      let payload = {};

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The request [getVatInfo] to Event [%s] on [OperationalScreen_WebshopOverview] succeeded",
            this.eventCalendar.EventId,
            response
          );

          this.vatList = [];
          this.vatList = [...response.data.Vat];
        },
        (error) => {
          console.log(
            "The request [getVatInfo] to Event [%s] on [OperationalScreen_WebshopOverview] failed",
            this.eventCalendar.EventId,
            error
          );
        },
        "getVatInfo",
        this.eventCalendar.EventId,
        payload
      );
    },
    intervalFormat(interval) {
      return interval.time;
    },
    getOrderById(order) {
      const payload = {
        OrderId: order.OrderId,
      };

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The request [getOrderById] to Event [%s] on [OperationalScreen_WebshopOverview] succeeded",
            this.eventCalendar.EventId,
            response
          );

          this.orderDetails = Object.assign({}, response.data);

          this.orderItems = [];
          response.data.Orders.forEach((orderItem) => {
            let orderItemTmp = Object.assign({}, orderItem);

            // Update unit price for Weighted product
            if (orderItemTmp.OrderItemType === this.ORDER_ITEM_TYPE_PRODUCT) {
              if (orderItemTmp.OrderProduct.ProductType === "Weighted") {
                if (orderItemTmp.OrderProduct.Quantity > 0) {
                  orderItemTmp.OrderProduct.ItemPrice = Number(
                    orderItemTmp.OrderProduct.ItemTotalPrice /
                      orderItemTmp.OrderProduct.Quantity
                  ).toFixed(5);
                }
              }
            }

            // Insert VatId to special request
            if(orderItemTmp.OrderItemType === this.ORDER_ITEM_TYPE_SPECIAL_REQUEST) {
              let i = this.vatList.findIndex(
                vat => vat.VatPercentage === orderItemTmp.OrderSpecialRequest.VatPercentage
              );

              if(i > -1) {
                 orderItemTmp.OrderSpecialRequest.VatId = this.vatList[i].VatId;
              } else {
                orderItemTmp.OrderSpecialRequest.VatId = "None";
              }
            }

            orderItemTmp.ReadMoreActivated = false;

            this.orderItems.push(orderItemTmp);
          });

          // Assign default value to StartDate and StartTime
          this.startDateSelected = order.StartDate;
          this.startTimeSelected = order.StartTime;
          this.endTimeSelected = order.EndTime;

          this.orderDetailsDialog = true;
        },
        (error) => {
          console.log(
            "The request [getOrderById] to Event [%s] on [OperationalScreen_WebshopOverview] failed",
            this.eventCalendar.EventId,
            error
          );
        },
        "getOrderById",
        this.eventCalendar.EventId,
        payload
      );
    },
    getItemUnit(orderItem) {
      let itemDetails = {};

      if (orderItem.OrderItemType === this.ORDER_ITEM_TYPE_PRODUCT) {
        itemDetails = Object.assign({}, orderItem.OrderProduct);
      } else if (
        orderItem.OrderItemType === this.ORDER_ITEM_TYPE_PRICE_CATEGORY ||
        orderItem.OrderItemType === this.ORDER_ITEM_TYPE_DELIVERY_COST
      ) {
        itemDetails = Object.assign({}, orderItem.OrderPriceCategory);
      } else if (
        orderItem.OrderItemType === this.ORDER_ITEM_TYPE_DELIVERY_FEE
      ) {
        itemDetails = Object.assign({}, orderItem.OrderDeliveryFee);
      }

      if (itemDetails.hasOwnProperty("Unit")) {
        if (itemDetails.Unit !== "") {
          return itemDetails.Unit;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    xTimeInterval() {
      setTimeout(this.getBookingCalendar, 300000);
    },
    deleteOrderItem(orderItem) {
      const itemIndex = this.orderItems.findIndex(
        (item) => item.OrderItemId === orderItem.OrderItemId
      );

      if (itemIndex > -1) {
        this.orderItems.splice(itemIndex, 1);
      }
    },
    getOrderStyle(order) {
      let orderStyleCurr = {};
      if (order.Status === this.ORDER_CONFIRMED) {
        // Green
        orderStyleCurr = {
          backgroundColor: "#008000",
          borderColor: "#008000",
        };
      } else if (order.Status === this.ORDER_CANCELLED) {
        // Gray
        orderStyleCurr = {
          backgroundColor: "#808080",
          borderColor: "#808080",
        };
      } else if (order.Status === this.ORDER_WAITING_FOR_PAYMENT) {
        // Orange
        orderStyleCurr = {
          backgroundColor: "#FFA500",
          borderColor: "#FFA500",
        };
      } else if (order.Status === this.ORDER_PARTNER_CONFIRMATION_NEEDED) {
        // Red
        orderStyleCurr = {
          backgroundColor: "#FF0000",
          borderColor: "#FF0000",
        };
      } else if(order.Status === this.ORDER_REQUESTED_PAYMENT) {
        // Blue
        orderStyleCurr = {
          backgroundColor: "#0000FF",
          borderColor: "#0000FF",
        };
      } else {
        // Purple
        orderStyleCurr = {
          backgroundColor: "#800080",
          borderColor: "#800080",
        };
      }

      return orderStyleCurr;
    },
    enableDateTimeSelection() {
      if (this.dateTimeDisabled) {
        this.getStartDates();
      }

      this.dateTimeDisabled = false;
    },
    getStartDates() {
      const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
      const today = new Date();
      const year = today.getFullYear();
      const month = toTwoDigits(today.getMonth() + 1);
      const day = toTwoDigits(today.getDate());
      const todayDate = `${day}-${month}-${year}`;
      const payload = {
        OrderType: "",
        StartDate: todayDate,
      };

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [getStartDates] on Event [%s] in component [OperationalScreen_WebshopOverview] succeeded",
            this.eventCalendar.EventId,
            response
          );

          this.startDates = [];
          this.startDates = [...response.data.StartDates];

          this.startTimes = [];
          this.startTimes = [...response.data.StartTimes];
        },
        (error) => {
          console.log(
            "The call [getStartDates] on Event [%s] in component [OperationalScreen_WebshopOverview] failed",
            this.eventCalendar.EventId,
            error
          );
        },
        "getStartDates",
        this.eventCalendar.EventId,
        payload
      );
    },
    getStartBatches() {
      let payload = {};

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [getStartBatches] on Event [%s] in component [OperationalScreen_WebshopOverview] succeeded",
            this.eventCalendar.EventId,
            response
          );

          this.startTimes = [];
          this.startTimes = [...response.data.StartTimes];
        },
        (error) => {
          console.log(
            "The call [getStartBatches] on Event [%s] in component [OperationalScreen_WebshopOverview] failed",
            this.eventCalendar.EventId,
            error
          );
        },
        "getStartBatches",
        this.eventCalendar.EventId,
        payload
      );
    },
    confirmBookingByPartner() {
      this.processingAcceptOrder = true;

      let payload = this.createPayloadForAcceptOrder();

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [updateOrder] on Event [%s] in component [OperationalScreen_WebshopOverview] succeeded",
            this.eventCalendar.EventId,
            response
          );

          this.processingAcceptOrder = false;
          this.successMsg = "Order has been processed successfully. You can check the status later.";
          this.successDialog = true;
        },
        (error) => {
          console.log(
            "The call [updateOrder] on Event [%s] in component [OperationalScreen_WebshopOverview] failed",
            this.eventCalendar.EventId,
            error
          );

          this.processingAcceptOrder = false;
          this.failureMsg = "There is an issue in the server when the order is being processed. Please try again later. If the problem persists, please contact the administrator.";
          this.failureDialog = true;
        },
        "updateOrder",
        this.eventCalendar.EventId,
        payload
      );
    },
    rejectBookingByPartner() {
      this.processingRejectOrder = true;

      let payload = {
        OrderId: this.orderDetails.OrderId,
      };

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [rejectOrder] on Event [%s] in component [OperationalScreen_WebshopOverview] succeeded",
            this.eventCalendar.EventId,
            response
          );

          this.processingRejectOrder = false;
          this.successMsg = "Order has been rejected successfully. You can check the status later.";
          this.successDialog = true;
        },
        (error) => {
          console.log(
            "The call [rejectOrder] on Event [%s] in component [OperationalScreen_WebshopOverview] failed",
            this.eventCalendar.EventId,
            error
          );

          this.processingRejectOrder = false;
          this.failureMsg = "There is an issue in the server when the order is being processed. Please try again later. If the problem persists, please contact the administrator.";
          this.failureDialog = true;
        },
        "rejectOrder",
        this.eventCalendar.EventId,
        payload
      );
    },
    closeOrderDetailsDialog() {
      this.orderDetailsDialog = false;
      this.dateTimeDisabled = true;
    },
    productItemQuantityChanged(orderItem) {
      // Update product item total price
      orderItem.OrderProduct.ItemTotalPrice = Number(
        orderItem.OrderProduct.Quantity * orderItem.OrderProduct.ItemPrice
      ).toFixed(2);
    },
    productItemTotalPriceChanged(orderItem) {
      // Update product item unit price
      // if(orderItem.OrderProduct.Quantity > 0) {
      //   orderItem.OrderProduct.ItemPrice = orderItem.OrderProduct.ItemTotalPrice / orderItem.OrderProduct.Quantity;
      // } else {
      //   return;
      // }
    },
    createPayloadForAcceptOrder() {
      let payload = {};
      payload.OrderId = this.orderDetails.OrderId;
      payload.EventId = this.eventCalendar.EventId;
      payload.Products = {};
      payload.PriceCategories = {};
      payload.SpecialRequests = [];
      payload.DeliveryFee = {};
      payload.StartBatch = {};

      // Order items
      for (let order of this.orderItems) {
        if (order.OrderItemType === this.ORDER_ITEM_TYPE_PRODUCT) {
          // Product
          let productId = order.OrderProduct.ProductId;
          let productItem = {
            ItemId: order.OrderProduct.ItemId,
            Quantity: order.OrderProduct.Quantity,
            TotalPrice: Number(order.OrderProduct.ItemTotalPrice),
            OrderItemId: order.OrderProduct.OrderItemId,
          };

          if (!payload.Products.hasOwnProperty(productId)) {
            payload.Products[productId] = {
              Id: order.OrderProduct.ProductId,
              Items: [],
            };
          }

          payload.Products[productId].Items.push(productItem);
        } else if (
          order.OrderItemType === this.ORDER_ITEM_TYPE_PRICE_CATEGORY ||
          order.OrderItemType === this.ORDER_ITEM_TYPE_DELIVERY_COST
        ) {
          // Price category
          let priceCategoryId = order.OrderPriceCategory.PriceCategoryId;
          payload.PriceCategories[priceCategoryId] = {
            Id: priceCategoryId,
            Quantity: order.OrderPriceCategory.Quantity,
            Price: Number(order.OrderPriceCategory.PriceCategoryPrice),
            OrderItemId: order.OrderPriceCategory.OrderItemId,
          };
        } else if (
          order.OrderItemType === this.ORDER_ITEM_TYPE_SPECIAL_REQUEST
        ) {
          let specialRequest = {
            Request: order.OrderSpecialRequest.SpecialRequest,
            Price: Number(order.OrderSpecialRequest.Price),
            VatId: order.OrderSpecialRequest.VatId,
            Response: order.OrderSpecialRequest.PartnerResponse,
            OrderItemId: order.OrderSpecialRequest.OrderItemId,
          };

          payload.SpecialRequests.push(specialRequest);
        } else if (order.OrderItemType === this.ORDER_ITEM_TYPE_DELIVERY_FEE) {
          payload.DeliveryFee.Price = Number(order.OrderDeliveryFee.DeliveryPrice);
          payload.DeliveryFee.OrderItemId = order.OrderDeliveryFee.OrderItemId;
        } else {
          console.error(
            "Received unknown order item type: ",
            order.OrderItemType
          );
        }
      }

      // Start batch
      payload.StartBatch.StartDate = this.startDateSelected;
      payload.StartBatch.StartTime = this.startTimeSelected;
      payload.StartBatch.EndTime = this.endTimeSelected;

      return payload;
    },
    sortOrdersMap() {
      Object.entries(this.ordersMap).forEach(([key, value]) => {
        value.sort((a, b) => {
          let timeA = moment(a.StartTime, "hh:mm");
          let timeB = moment(b.StartTime, "hh:mm");
          return timeA.isBefore(timeB);
        });
      });
    },
    getPartnerResponseLabel(orderSpecialRequest) {
      if (this.orderDetails.Status !== this.ORDER_PARTNER_CONFIRMATION_NEEDED) {
        // Not able to edit the request, view mode
        if (orderSpecialRequest.PartnerResponse === "") {
          return "No response";
        } else {
          return orderSpecialRequest.PartnerResponse;
        }
      } else {
        // In the edit mode
        return "Add a response";
      }
    },
    closeSuccessDialog() {
      this.successDialog = false;
      this.successMsg = '';
      this.orderDetailsDialog = false;
      this.getBookingCalendar();
    },
    closeFailureDialog() {
      this.failureDialog = false;
      this.failureMsg = '';
      this.orderDetailsDialog = false;
      this.getBookingCalendar();
    },
    readMoreRequest(orderItem) {
      orderItem.ReadMoreActivated = true;
    },
    readLessRequest(orderItem) {
      orderItem.ReadMoreActivated = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.newFontSize {
  font-size: 100%;
}
.cardTitle {
  text-align: center;
}
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid white;
  font-size: 9px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 0px;
  margin-right: 8px;
  position: relative;

  &.with-time {
    width: 30px;
    position: absolute;
    right: 4px;
    margin-right: 0px;
    background-color: #1867c0;
  }
  &.with-time-large {
    position: absolute;
    right: 4px;
    margin-right: 0px;
    background-color: #1867c0;
  }
}
.calendar {
  position: relative;
  height: 300px;
  max-width: 100%;
}
.scrollingPossible {
  overflow-y: auto;
  overflow-x: auto;
  padding-bottom: 1em;
}
</style>

<style lang="scss">
.v-calendar-daily_head-day-label {
  font-size: 25px !important;
  padding: 0 4px 4px 8px;
  line-height: 40px;
  cursor: pointer;
}
</style>
